import {
  GET_COUNTRY_FAIL,
  GET_COUNTRY_REQUEST,
  GET_COUNTRY_SUCCESS,
  GET_COUNTRY_CODES_FAIL,
  GET_COUNTRY_CODES_REQUEST,
  GET_COUNTRY_CODES_SUCCESS,
  GET_REGION_FAIL,
  GET_REGION_REQUEST,
  GET_REGION_SUCCESS,
  GET_TIMEZONE_FAIL,
  GET_TIMEZONE_REQUEST,
  GET_TIMEZONE_SUCCESS,
} from "../constant";

const initialState = {
  locationData: [],
  countryData: [],
  countryCodesData: [],
  countryCodesLoading: false,
  regionData: [],
  timeZoneData: [],
  timezoneDataLoading: false,
  countryDataLoading: false,
  regionDataLoading: false,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTRY_REQUEST:
      return {
        ...state,
        countryDataLoading: true,
      };
    case GET_COUNTRY_SUCCESS:
      return {
        ...state,
        countryData: action.payload,
        countryDataLoading: false,
      };
    case GET_COUNTRY_FAIL:
      return {
        ...state,
        countryData: [],
        countryDataLoading: false,
      };
    case GET_REGION_REQUEST:
      return {
        ...state,
        regionDataLoading: true,
      };
    case GET_REGION_SUCCESS:
      return {
        ...state,
        regionData: action.payload,
        regionDataLoading: false,
      };
    case GET_REGION_FAIL:
      return {
        ...state,
        regionData: [],
        regionDataLoading: false,
      };
    case GET_TIMEZONE_REQUEST:
      return {
        ...state,
        timezoneDataLoading: true,
      };
    case GET_TIMEZONE_SUCCESS:
      return {
        ...state,
        timeZoneData: action.payload,
        timezoneDataLoading: false,
      };
    case GET_TIMEZONE_FAIL:
      return {
        ...state,
        timeZoneData: [],
        timezoneDataLoading: false,
      };
    case GET_COUNTRY_CODES_REQUEST:
      return {
        ...state,
        countryCodesLoading: true,
      };
    case GET_COUNTRY_CODES_SUCCESS:
      return {
        ...state,
        countryCodesData: action.payload,
        countryCodesLoading: false,
      };
    case GET_COUNTRY_CODES_FAIL:
      return {
        ...state,
        countryCodesData: [],
        countryCodesLoading: false,
      };
    default:
      return state;
  }
};
export { locationReducer };
